import React from "react";
import BaseService from "../../utils/BaseService";
import {
  getAppMeetingLink,
  getDecodedDataFromWebinarLink,
  getMeetingTypeFromUrl,
} from "../ZoomPage/ZoomUtils";
import { isMobile } from "../../utils/CommonUtils";

const ZoomAuth = () => {
  const [state, setState] = React.useState({
    loading: false,
    appMeetingLink: "",
    browserMeetingLink: "",
  });
  const meetingObj = getDecodedDataFromWebinarLink(window.location.href);
  const type = getMeetingTypeFromUrl();

  const getMeetingParticipantData = async () => {
    setState((prev) => {
      return {
        ...prev,
        loading: true,
      };
    });
    try {
      const baseService = BaseService.getSharedInstance().axios;
      const url =
        type && type === "MEETING"
          ? "crm-communication/meeting/link"
          : "crm-communication/webinar/link";
      const response = await baseService.post(url, meetingObj);
      const link = response.data.link;
      window.open(link, "_self");
      return;
      // app deep link handling for patient mobile
      // if (!isMobile() || meetingObj.userUuid) {
      //   setState((prev) => {
      //     return {
      //       ...prev,
      //       loading: false,
      //     };
      //   });
      //   window.open(link, "_self");
      //   return;
      // }
      // const appMeetingLink = await getAppMeetingLink({
      //   contactUuid: meetingObj.contactUuid,
      //   meetingType: meetingObj.meetingId ? "MEETING" : "WEBINAR",
      //   meetingOrWebinarId: meetingObj.meetingId || meetingObj.webinarId,
      // });
      // setState((prev) => {
      //   return {
      //     ...prev,
      //     loading: false,
      //     appMeetingLink,
      //     browserMeetingLink: link,
      //   };
      // });
    } catch (error) {
      setState((prev) => {
        return {
          ...prev,
          loading: false,
        };
      });
    }
  };
  React.useEffect(() => {
    getMeetingParticipantData();
  }, []);

  if (!isMobile()) {
    return <div></div>;
  }

  return (
    <div
      style={{
        backgroundColor: "white",
        height: "100vh",
        width: "100vw",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {state.loading ? (
        <h1
          style={{
            color: "black",
          }}
        >
          Loading...
        </h1>
      ) : (
        <div
          style={{
            backgroundColor: "white",
            height: "100vh",
            width: "100vw",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <button
            style={{
              backgroundColor: "#825AC7",
              color: "white",
              padding: 10,
              borderRadius: 20,
              margin: "10px 10px",
            }}
          >
            <a
              style={{
                textDecoration: "none",
                color: "white",
              }}
              href={`${state.browserMeetingLink}`}
            >
              Continue on Browser
            </a>
          </button>
          <button
            style={{
              backgroundColor: "#825AC7",
              color: "white",
              padding: 10,
              borderRadius: 20,
              margin: "10px 10px",
            }}
          >
            <a
              style={{
                textDecoration: "none",
                color: "white",
              }}
              href={`${state.appMeetingLink}`}
            >
              Open in App
            </a>
          </button>
        </div>
      )}
    </div>
  );
};

export default ZoomAuth;
